import React from 'react';
import PolicyLayout from '../components/PolicyLayout';

export const PrivacyPolicy = () => (
  <PolicyLayout title="Privacy Policy">
    <p>At Kshitiz Fitness, we value your privacy. We collect basic information like your name, email, and phone number to provide community access and fitness services.</p>
    <p>Your data is securely processed and is never sold to third parties. Payment details are handled by our secure partner, Cashfree Payments; we do not store your card or UPI details on our servers.</p>
  </PolicyLayout>
);

export const TermsConditions = () => (
  <PolicyLayout title="Terms & Conditions">
    <p>By joining the community, you agree to follow our code of conduct. All content provided is for educational and fitness purposes only.</p>
    <p>Consult with a medical professional before starting any new exercise program. Kshitiz Fitness is not liable for any injuries sustained during your personal training journey.</p>
  </PolicyLayout>
);

export const RefundPolicy = () => (
  <PolicyLayout title="Refund & Cancellation">
    <p><strong>Important:</strong> Due to the digital nature of our community access and recorded webinar lectures, all purchases are final.</p>
    <p>Once access is granted to the WhatsApp community or the digital vault, we cannot provide any refunds or cancellations. By completing your purchase, you acknowledge and agree to this policy.</p>
  </PolicyLayout>
);

export const ContactUs = () => (
  <PolicyLayout title="Contact Us">
    <p>If you have any questions or technical issues regarding your purchase, feel free to reach out to our team:</p>
    <div className="bg-dark-grey p-6 rounded-2xl border border-zinc-800 space-y-4">
      <p>📧 <strong>Email:</strong> kshitizbisht2000@gmail.com</p>
      <p>📱 <strong>WhatsApp Support:</strong> +91 7983280357</p>
      <p>📍 <strong>Address:</strong> [Uttarakhand, India]</p>
    </div>
  </PolicyLayout>
);
